import React, { useState } from "react";
import { uploadDataset, extractErrorMessage } from "../../services/adminApi";

const DatasetUploadEditor = () => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");
    const [result, setResult] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files?.[0] || null);
        setResult(null);
        setError("");
    };

    const handleUpload = async () => {
        if (!file) return;
        const confirmed = window.confirm(
            "Загрузка заменит ВСЕ объекты и регионы на карте содержимым " +
                "этого файла. Действие необратимо (кроме отката из бэкапа " +
                "на сервере вручную). Продолжить?"
        );
        if (!confirmed) return;

        setUploading(true);
        setError("");
        setResult(null);
        try {
            const data = await uploadDataset(file);
            setResult(data);
        } catch (err) {
            setError(
                extractErrorMessage(err, "Не удалось загрузить и обработать файл")
            );
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="admin-section">
            <h2 className="admin-section-title">Данные — каталог объектов</h2>
            <p className="admin-hint">
                Загрузите .xlsx в том же формате, что и текущий файл
                (структура столбцов как в исходной таблице проекта). После
                загрузки все объекты и регионы на карте будут пересобраны
                заново из этого файла — это займёт одну-две минуты на
                файле с тысячами строк. Предыдущий файл сохраняется в
                бэкапе на сервере перед заменой.
            </p>

            <label className="admin-field">
                <span>Файл .xlsx</span>
                <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
            </label>

            <button
                type="button"
                className="admin-primary-button"
                onClick={handleUpload}
                disabled={!file || uploading}
            >
                {uploading ? "Загружаем и пересчитываем…" : "Загрузить и заменить"}
            </button>

            {error && <p className="admin-error">{error}</p>}
            {result && (
                <p className="admin-saved-hint">
                    Готово: загружено {result.deposits} объектов.
                </p>
            )}
        </div>
    );
};

export default DatasetUploadEditor;
